// imports
import { Box, Chip, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

// components
import { CardMenu } from '../../../common/CardMenu';

// constants, helper, interfaces
import { CardTypes, PAYMENT_METHOD_NOT_FOUND } from 'constants/index';
import { PaymentCardsProps } from 'interfaces';
import { getCardIcon } from 'lib/helper';
import { CreditCardBox } from 'styles/commonComponentStyle';

const PaymentCards: FC<PaymentCardsProps> = ({ paymentMethods, handleSuccess }) => {
  const theme = useTheme();

  return (
    <Box>
      {paymentMethods?.length ? (
        paymentMethods.map((card) => (
          <CreditCardBox key={card.id} mt={2}>
            <Box display="flex" alignItems="center" gap={2}>
              {getCardIcon(card.brand as CardTypes)}
              <Box>
                <Typography variant="subtitle2" color={theme.palette.common.white} fontWeight={600}>
                  {card.name}
                </Typography>
                <Typography variant="subtitle2" color={theme.palette.common.white} fontWeight={600}>
                  **** **** **** {card.last4}
                </Typography>
              </Box>
              {card.default && <Chip label="Default" size="small" color="success" />}
            </Box>
            <CardMenu cardId={card.id} handleSuccess={handleSuccess} isDefault={Boolean(card.default)} />
          </CreditCardBox>
        ))
      ) : (
        <Typography variant="body1" mt={2}>
          {PAYMENT_METHOD_NOT_FOUND}
        </Typography>
      )}
    </Box>
  );
};

export default PaymentCards;
